module.exports = __webpack_public_path__ + "img/screen_adaptation_add.6d43656f.svg";